import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isMacOs } from '@travel/traveler-core/utils';
import { cx } from '@travel/utils';

import { pushLocation } from 'store/__router/actions';

import { getBaseUrl, getHost, getProtocol } from 'store/__router/selectors';

import styles from './link.module.scss';

import type { MouseEvent, ReactNode } from 'react';
import type { HTMLProps } from 'react';

type Props = {
  to: string;
  children: ReactNode;
  isLink?: boolean;
  href?: string;
} & HTMLProps<HTMLAnchorElement>;

export const getHref = (host: string, to: string, protocol?: string) => {
  return `${protocol ? `${protocol}://` : ''}${host || ''}${to}`;
};

export function Link(props: Props) {
  const { to, className, isLink, href, ...restProps } = props;

  const dispatch = useDispatch();
  const host = useSelector(getHost);
  const baseUrl = useSelector(getBaseUrl);
  const protocol = useSelector(getProtocol);

  const handleClick = (e: MouseEvent | React.KeyboardEvent<HTMLAnchorElement>) => {
    const openInNewTab = isMacOs() ? e.metaKey : e.ctrlKey;
    if (!openInNewTab && props.onClick) {
      props.onClick(e as MouseEvent<HTMLAnchorElement>);
    } else if (!openInNewTab) {
      e.preventDefault();
      dispatch(pushLocation(to));
    }
  };
  return (
    <a
      className={cx(!isLink && styles.wrapper, className)}
      {...restProps}
      onClick={!href ? handleClick : undefined}
      href={href || getHref(host + baseUrl, to, protocol)}
      tabIndex={0}
    >
      {props.children}
    </a>
  );
}

export default Link;
